/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'boolean',
    },
  },
  required: ['value'],
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    enabled_custom_info: valueSchema,
  },
}
